<template>
<div class="profile-content container">
      <div class="row">
         <div class="col-md-4 col-sm-12">
            <div class="user-details" id="displayprofile" v-if="! isEdit">
               <div class="pic">
                 
                  <div v-if="basicProfile.profileImg != ''" id="image" class="img-edit" >
                     <b-tooltip target="image" title="Edit profile"></b-tooltip>
                     <img :src="basicProfile.profileImg" width="200" height="200">
                     <button class="btn btn-edit" @click="editBasicProfile">
                     <i class="mdi mdi-pencil"></i>
                     </button>
                  </div>
                  <div v-if="basicProfile.profileImg == ''" id="image" class="img-edit">
                     <img src="../../../static/assets/images/user.png" alt="">
                     <button class="btn btn-edit" v-if="instanceName !== 'MAHADEMY'"  @click="editBasicProfile">
                     <i class="mdi mdi-pencil"></i>
                     </button>
                  </div>
                  <!-- "../../../static/assets/images/user.png" -->
                  <br><br>
                  <div v-if="basicProfile.profileImg != ''">
                    <button class="btn btn-danger btn-block text-center" @click="DeleteFile(basicProfile.profileImg)">Remove Profile Picture</button>
                  </div>
                  <br>
                  <div class="title">
                     <div>{{basicProfile.fullName}} </div>
                  </div>
               </div>
               <hr/>
               <div class="details">
                  <div class="topic">{{$t('profileDetails.placeholder.contact')}} :</div>
                  <div v-for="(accountInfo,index) in basicProfile.accountDetails" :key ="index">
                    <div>
                      <span><b>{{$t('profileDetails.placeholder.AccountType')}} : </b>{{accountInfo.jvId}}</span><br>
                      <!-- {{accountInfo}} -->
                      <span v-if ="accountInfo.email!= undefined && accountInfo.email != null && accountInfo.email.length > 0" ><b> {{$t('profileDetails.placeholder.email')}} : </b>{{accountInfo.email}}</span><br  v-if ="accountInfo.email!= undefined && accountInfo.email.length > 0">
                      <span v-if ="accountInfo.mobile!= undefined && accountInfo.mobile != null && accountInfo.mobile.length > 0"><b>{{$t('profileDetails.placeholder.mobile')}}  : </b>{{accountInfo.mobile}}</span><br  v-if ="accountInfo.mobile!= undefined && accountInfo.mobile.length > 0">
                      <span v-if ="accountInfo.portedUserName != undefined && accountInfo.portedUserName != null && accountInfo.portedUserName.length > 0"><b>Username : </b>{{accountInfo.portedUserName}}</span><br  v-if ="accountInfo.portedUserName.length != undefined && accountInfo.portedUserName.length > 0">
                      <br v-if="index + 1 < basicProfile.accountDetails.length">
                    </div>
                    <hr v-if="index + 1 === basicProfile.accountDetails.length">
                  </div>
               </div>
               <!-- <hr> -->
               <!-- account linking  -->

                <!-- <div class="details" v-if="instanceName !== 'MAHADEMY'">
                  <div class="topic">Linked Accounts:</div>
                    <div v-if ="isAccountLinked('GOOGLE')"> 
                      <span><i class="mdi mdi-google"></i></span>&nbsp;<span>Google Account Linked</span>
                    </div>
                    <div v-else style="cursor:pointer">
                      <g-signin-button class="mdi mdi-google"
                        :params="googleSignInParams"
                        @success="onSignInSuccess"
                        @error="onSignInError">
                        Link Google Account
                      </g-signin-button>
                    </div>  
               </div> -->
               
               <div class="details" v-if="$store.getters.getProfileDetails.mobile != undefined && $store.getters.getProfileDetails.mobile != null" >
                  <div class="topic">Contact</div>
                  <span v-if="$store.getters.getProfileDetails.mobile.length !== 0">{{$store.getters.getProfileDetails.mobile}}</span>
                  <span v-else>Add contact details</span>
               </div>
               <hr  v-if="instanceName !== 'MAHADEMY'">
                <div v-if ="skills != undefined && skills != null && skills.length > 0" class="details">
                    <div class="topic">skills</div>
                    <div v-for ="(skill,i) in skills" :key = i >
                      <span>{{skill}}</span>
                    </div>
                    <hr/> 
                </div>
 
               <div class="details">
                  <div class="topic">{{$t('profileDetails.labels.aboutMe')}}</div>
                  <span v-if="basicProfile.aboutMe == ''" >{{$t('profileDetails.labels.Hi_I_am')}} {{basicProfile.fullName}}</span>
                  <span v-else >{{basicProfile.aboutMe}}</span>
               </div>
               <hr/>
  

               <button class="btn btn-blue btn-block" @click="editBasicProfile">
               {{$t('profileDetails.labels.editButtonText')}}</button>
            </div>
            <div class="user-details" id="editprofile" v-if="isEdit">
               <div class="row">
                  <div class="col-md-12 upload-pic" v-if="instanceName !== 'MAHADEMY'">
                     <!-- <vue-dropzone  ref="myVueDropzone" id="dropzone" @vdropzone-error="ErrorUploading" @vdropzone-success="ChangeProfilePic" v-on:vdropzone-removed-file="clearFiles" @vdropzone-file-added="fileAdded" :options="dropzoneOptions">
                     </vue-dropzone> -->

                    <div class="col-md-12">
                      <div class="topic">Your Profile Picture</div>
                        <vue-cropper
                          ref='cropper'
                          :guides="true"
                          :view-mode="2"
                          drag-mode="crop"
                          :auto-crop-area="1"
                          :min-container-width="150"
                          :min-container-height="80"
                          :background="true"
                          :rotatable="true"
                          :src="getImageSrc()"
                          :img-style="{ 'width': '300px', 'height': '200px' }">
                        </vue-cropper>
                        <span class="text-danger" v-if="fileExceedLimit"><b> Image size should be less than {{maxFilesize * 1000 }} kb</b></span>
                        <br/>
                        <div class="text-center">
                          <button  class="btn btn-blue " @click="cropImage" v-if="imgSrc != ''" :disabled="fileExceedLimit">Crop</button>
                          <button   class="btn btn-blue " @click="uploadImage" v-if="imgSrc != ''"  :disabled="fileExceedLimit">Upload</button>
                        </div>  
                      </div>
                      <br/>
                      <div class="topic">
                        <span >Select new profile image</span>
                        <input type="file" class="form-control" name="image" id="imgUpload" accept="image/*" style="font-size: 1.2em; padding: 10px 0;" @change="setImage" />
                      </div>
                      <br/>
                      <hr>

                     <!--  <vue-cropper
                            ref='cropper'
                            :guides="true"
                            :view-mode="2"
                            drag-mode="crop"
                            :auto-crop-area="1"
                            :min-container-width="150"
                            :min-container-height="80"
                            :background="true"
                            :rotatable="true"
                            :src="getImageSrc()"
                            :img-style="{ 'width': '300px', 'height': '200px' }">
                      </vue-cropper> -->
                     <!-- <div>
                       <span class="text-danger" v-if="fileExceedLimit"><b> Image size should be less than {{maxFilesize}} MB</b></span>
                     </div>
                    <br/>
                    <button @click="cropImage" v-if="imgSrc != ''" style="margin-right: 40px;" :disabled="fileExceedLimit">Crop</button>
                    <button @click="uploadImage" v-if="imgSrc != ''" style="margin-right: 40px;" :disabled="fileExceedLimit">Upload</button>
                    <br> -->
                    <!-- <input type="file" name="image" id="imgUpload" accept="image/*"
                        style="font-size: 1.2em; padding: 10px 0;"
                        @change="setImage" />
                    <br/> -->


                    
                       

                    <!-- <img :src="cropImg" alt="Cropped Image" /> -->
                    
                    <!-- <button @click="rotate" v-if="imgSrc != ''">Rotate</button> -->
                                    <!-- <input type="file" @change="onFileChanged"> -->
                  </div>
                  <!-- <div style="width:100px;height:100px">
                    <img :src="cropImg" alt="Cropped Image" />
                  </div> -->
                  <div class="col-md-12">
                     <div class="topic">{{$t('profileDetails.labels.yourName')}}</div>
                     <input ref="name" type="text" class="form-control" id="name" :placeholder="$t('profileDetails.placeholder.YourFullName')" value='Neha Sharma' v-model="in_name">
                  </div>
               </div>
               <hr>
              <div class="details" v-if="$store.getters.getProfileDetails.mobile != undefined && $store.getters.getProfileDetails.mobile != null && $store.getters.getProfileDetails.mobile.length == 0" >
                <div class="topic">{{$t('profileDetails.placeholder.contact')}}</div>
                <input v-model="mobile" :placeholder="$store.getters.getProfileDetails.mobile.length ===  0 ? 'Enter contact details': '' ">
              </div>
               
               <div class="topic">{{$t('profileDetails.labels.aboutMe')}}</div>
               <textarea type="text" class="form-control" rows="3" :placeholder="$t('profileDetails.placeholder.WriteAboutYourself')" v-model="in_aboutMe" />
               <hr/>
               <button class="btn btn-blue btn-block" @click="saveBasicProfile"> {{$t('profileDetails.labels.saveButtonText')}}</button>
            </div>
         </div>
         <div class="col-md-8 col-sm-12">
            <div class="card-tabs">
               <div class="tabs-css">
                  <b-tabs>
                     <hr/>
                     <!-- courses -->
                     <b-tab :title="$t('profileDetails.labels.PurchasedCourses')">
                        <div class="card-design card-design-profile" v-for="(course,i) in enrolledCourses" :key="i">
                            <div  class="row">
                              <div class="col-md-4">
                                  <div  v-if="checkValue(course.thumbnail)">
                                    <img :src="makePath(course.thumbnail)" class="img-fluid card-design__img" alt="">
                                  </div>
                                  <div v-else>
                                    <img src="../../../static/assets/images/defaultCO.jpg" class="img-fluid card-design__img" alt="">
                                  </div>
                              </div>
                                <div class="col-md-8 align-self-center">
                                  <h5 class="card-design__data-heading" @click="learnCourse(course)" >{{course.title}}</h5>

                                    <div class="card-design__data-cost" v-if="instanceName !== 'MAHADEMY'">
                                      {{$t('profileDetails.labels.Course_starts_on')}} <span>{{course.purchasedDate | moment("Do MMM, YYYY ")}}</span>
                                      {{$t('profileDetails.labels.and_expires_on')}}<span>{{course.expiryDate | moment("Do MMM, YYYY ")}}</span>
                                    </div>
                                    <div class="card-design__details" >
                                        <!-- <span> {{$t('profileDetails.l.abels.CourseCompletionStatus')}} </span> <strong>{{course.allocationDetails == undefined ? 0 :course.allocationDetails.completionPercentage }}</strong>  -->
                                        <div class="card-design__metadata" v-if="instanceName !== 'MAHADEMY'">
                                          <span>{{$t('profileDetails.labels.You\'ve_solved')}} <strong>{{course.allocationDetails == undefined ? 0:course.allocationDetails.solvedChallengeCount}}</strong> {{$t('profileDetails.labels.challenges')}} </span>
                                          <!-- {{course.allocationDetails == undefined ? 0 : course.allocationDetails.timeSpent}} -->
                                          <span> {{$t('profileDetails.labels.and_completed')}} <strong> {{course.allocationDetails == undefined ? 0 : course.allocationDetails.completedAggregationCount}} </strong>{{$t('profileDetails.labels.lectures')}} </span>
                                          <span> {{$t('profileDetails.labels.out_of')}} <strong> {{course.allocationDetails == undefined ? 0 : course.allocationDetails.courseMetadata.totalAggregations}} </strong> </span>
                                        </div>
        
                                        <div v-if="instanceName !== 'MAHADEMY'" class="card-design__data-cost">Course costs {{course.price}} {{course.price > 1 ? 'Points' : 'Point'}}</div>
                                        
                                        <div class="row card-design__data-ratings">
                                          <div class="col" v-if="instanceName !== 'MAHADEMY'">
                                              <span class="ratingText"> {{$t('profileDetails.labels.My_Rating')}} </span>  
                                              <!-- <star-rating :rating="course.rating"  v-bind:increment="0.5" :read-only=true @rating-selected="setRating" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                                              </star-rating> -->
                                              <star-rating :rating="course.rating"  v-bind:increment="0.5"  @rating-selected="setRating" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                                              </star-rating>
                                          </div>
                                          <!-- share widgets -->
                                          <div class="col-auto">                     
                                              <share-on-media :item="course"  :labelOnTop="false"></share-on-media> 
                                          </div>
                                        </div>
  
                                    </div> 
                                </div>
                            </div>
                        </div>    
                        <div v-if="enrolledCourses.length == 0">
                           <div class="noticemsg-alt">
                              <span>{{$t('course.noCourses')}}
                               <router-link to="home" class="linkcss">courses!</router-link>
                               </span>
                           </div>
                        </div>
                     </b-tab>

                      <!-- single concepts -->
                     <b-tab v-if="instanceName !== 'MAHADEMY'" :title="$t('profileDetails.labels.PurchasedVideos')" >
                        <div class="card-design card-design-profile" v-for="(lo,j) in $store.getters.getUserSingleConceptsCollection" :key="j">
                           <div  class="row">
                              <div class="col-md-4" v-if="checkValue(lo.thumbnail)">
                                 <img :src="makePath(lo.thumbnail)" class="img-fluid card-design__img" alt="">
                                 
                              </div>
                              <div class="col-md-4" v-else>
                                 <img src="../../../static/assets/images/defaultLO.jpg" class="img-fluid card-design__img" alt="">
                                
                              </div>
                              <div class="col-md-8 align-self-center">

                                 <h5 class="card-design__data-heading no-line" @click="learnLO(lo)">{{lo.title}}</h5>

                                    <div class="card-design__details" v-if="instanceName !== 'MAHADEMY'">
                                        <div class="card-design__data-cost">
                                          <!-- <span>{{$t('profileDetails.labels.PurchasedOn')}} </span> -->
                                          {{$t('profileDetails.labels.item_purchased_on')}}
                                            <span> {{lo.purchasedDate | moment("Do MMM, YYYY ")}} </span>
                                            <!-- <span>{{$t('profileDetails.labels.ExpiresOn')}} </span> -->
                                            {{$t('profileDetails.labels.item_expires_on')}}
                                            <span> {{lo.expiryDate | moment("Do MMM, YYYY ")}} </span>
                                        </div>
                                           
                                     </div>
                                     <div class="card-design__data-cost" v-if="instanceName !== 'MAHADEMY'">Single concept costs {{lo.price}} {{lo.price > 1 ? 'Points' : 'Point'}}</div>
                                    <div v-if="lo.courseType === 'LO'" @click="showRating(lo.contentId)">
                                      <br/>
                                      <span class="ratingText" v-if="instanceName !== 'MAHADEMY'"> Your Rating </span>
                                      <star-rating  :rating="lo.rating"  v-bind:increment="0.5" @rating-selected="setRating" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                                        </star-rating>

                                    </div>  

                              </div>
                           </div>
                            

                        </div>
                         <router-link to="playlist" class="btn btn-blue" style="text-color:#eee">{{$t('profileDetails.placeholder.SeeMore')}}</router-link>
                        <div v-if="enrolledLOs.length == 0">
                           <div class="noticemsg-alt">
                              <span>{{$t('profileDetails.labels.noLO')}}
                               <router-link to="home" class="linkcss"> concepts! </router-link>
                              </span>
                           </div>
                        </div>

                 
                     </b-tab>

                     <!-- playList -->
                     <b-tab v-if="instanceName !== 'MAHADEMY'" :title="$t('profileDetails.labels.Playlist')">
                        <div class="card-design card-design-profile" v-for="playlist in playLists" :key="playlist.plId" v-if="!playlist.isWishList">
                          <div class="row">
                            <div class="col-md-4">
                                <img src="../../../static/assets/images/defaultLO.jpg" class="img-fluid card-design__img" alt="">
                                <!-- <span class="play-icon"><i class="mdi mdi-play-circle"></i></span> -->
                            </div>
                            <div class="col-md-8 align-self-center">
                                <!-- <h5>{{playlist}}</h5> -->
                                <h5 class="card-design__data-heading">{{playlist.plName}}</h5>
                                <div  class="card-design__details">
                                  <div v-if="(playlist.items.length<=1)">
                                    <span >{{$t('No. of Concept')}}</span> <strong> {{playlist.items.length}}</strong>  
                                  </div>
                                  <div  v-else>
                                    <span> {{$t('No. of Concepts')}}</span> <strong> {{playlist.items.length}}</strong>  
                                  </div>
                                </div> 

                                <div v-if="playlist.items.length == 0" class="action-btn" >
                                  <button class="btn btn-blue" @click="goToPlaylist"> {{$t('profileDetails.labels.watchButtonText')}}</button>
                                </div>
                                <div v-else class="action-btn">
                                  <button class="btn btn-blue" @click="goToContentViewer(playlist)"> {{$t('profileDetails.labels.watchButtonText')}}</button>
                                </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="playLists.length == 0">
                           <div class="noticemsg-alt">
                              <span>
                                 {{$t('playlist.noPlaylists')}}
                                 <router-link to="playlist" class="linkcss">{{$t('common.labels.now')}}!</router-link>
                              </span>
                           </div>
                        </div>
                     </b-tab>

                  </b-tabs>
               </div>
            </div>
         </div>
      </div>
      <div class="loader-wraper" v-show="loading===true">
         <div class="loader-box">
            <div class="lds-roller">
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
            </div>
            <h6 class="mt-2">{{$t('profileDetails.labels.PleaseWait')}}</h6>
         </div>
      </div>
</div>
</template>
<script>
import {CDN_CLIENTHEADER, CDN_BUSSINESSHEADER, IMAGE_UPLOAD_MAX_SIZE, CDP_CDN_THUMBNAIL_URL, CDN_UPLOAD_URL, CDN_DELETE_URL, THIRDPARTY_GOOGLE_USER, GOOGLE_SIGN_IN_APP_ID, LIVEDEMY_DEFAULT_USER, INSTANCE_NAME} from '@/components/common/constants.js'
// import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'
import vue2Dropzone from '@/components/vue2-dropzone/vue-dropzone.vue'
import InputTag from 'vue-input-tag'
import PictureInput from 'vue-picture-input'
import axios from 'axios'
import StarRating from 'vue-star-rating'
import ShareOnMedia from '../common/shareOnMedia'
import VueCropper from 'vue-cropperjs'
// import * as constants from '../common/constants.js'
// import DropZone from 'vue-dropzone'
export default {
  name: 'profileContent',
  components: {
    vueDropzone: vue2Dropzone,
    InputTag,
    StarRating,
    PictureInput,
    ShareOnMedia,
    VueCropper
  },
  data () {
    return {
      instanceName: INSTANCE_NAME,
      userSingleConceptCollection: [],
      userCategory: LIVEDEMY_DEFAULT_USER,
      googleSignInParams: {
        client_id: GOOGLE_SIGN_IN_APP_ID
      },
      editDOB: true,
      monthList: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      config: {
        format: 'YYYY/MM/DD',
        useCurrent: false
      },
      dob: '',
      skills: [],
      rating: 0.0,
      loading: false,
      dropzoneOptions: {
        acceptedFiles: 'image/*',
        url: '2456',
        thumbnailWidth: 150,
        thumbnailHeight: 100,
        maxFiles: 1,
        maxFilesize: IMAGE_UPLOAD_MAX_SIZE,
        addRemoveLinks: true,
        dictDefaultMessage: 'Drop image here to upload maxsize:512kb',
        headers: { 'Bussiness-Code': 'ERA', 'Client-Code': 'LiveDemy' },
        autoProcessQueue: true,
        dictMaxFilesExceeded: 'Extra File',
        uploadMultiple: false
      },
      maxFilesize: IMAGE_UPLOAD_MAX_SIZE,
      imgSrc: this.$store.getters.getProfileDetails.profileImg,
      cropImg: '',
      selectedFile: null,
      bussiness_header: CDN_BUSSINESSHEADER,
      client_header: CDN_CLIENTHEADER,
      in_name: '',
      in_designation: '',
      in_email: '',
      in_aboutMe: '',
      in_skills: [],
      isEdit: false,
      in_profileImage: '',
      EnrolledCourseDetails: [],
      fileExceedLimit: false,
      mobile: '',
      isCropped: false
    }
  },
  computed: {
    basicProfile () {
      return this.$store.getters.getProfileDetails
    },
    playLists () {
      return this.$store.getters.getUserPlaylists
    },
    enrolledCourses () {
      return this.$store.getters.getItemsEnrolledByType('CO')
    },
    enrolledLOs () {
      return this.$store.getters.getItemsEnrolledByType('LO')
    }
  },
  methods: {
    getImageSrc () {
      if (this.imgSrc.length === 0) {
        this.imgSrc = '../../../static/assets/images/user.png'
        return '../../../static/assets/images/user.png'
      } else {
        return this.imgSrc
      }
    },
    linkNewAccountDetails (profileId, thirdParty, email, identificationNo) {
      return new Promise((resolve, reject) => {
        axios
        .post('r/linkSocialAccount', {'profileId': this.$store.getters.getProfileDetails.profileId, 'accountDetails': [{'jvId': thirdParty, 'identificationNumber': identificationNo, 'portedUserName': email}]})
        .then(res => {
          this.$toasted.success(thirdParty + ' account linked successfully')
          this.$store.dispatch('addLinkedAccountsDetailsInStore', {'jvId': thirdParty, 'identificationNumber': identificationNo, 'portedUserName': email, 'isActive': true, 'isOnline': false}).then(res => {
            resolve(true)
          }, err => {
            console.log('ERROR_IN_ADDING_ACCOUNT_DETAILS_IN_STORE : ', err)
            reject(err)
          })
        })
        .catch(err => {
          console.log('ERROR_IN_ADDING_CONTACT_DETAILS : ', err)
          reject(false)
        })
      })
    },
    isAccountLinked (thirdParty) {
      for (let i = 0; i < this.$store.getters.getProfileDetails.accountDetails.length; i++) {
        if (this.$store.getters.getProfileDetails.accountDetails[i].jvId === thirdParty) {
          return true
        } else {
          if (i + 1 === this.$store.getters.getProfileDetails.accountDetails.length) {
            return false
          }
        }
      }
    },
    onSignInSuccess (googleUser) {
      /*
        googleUser.w3.U3 // email
        googleUser.w3.Eea // identification number
      */
      // console.log(JSON.stringify(googleUser))
      this.linkNewAccountDetails(this.$store.getters.getProfileDetails.profileId, THIRDPARTY_GOOGLE_USER, googleUser.w3.U3, googleUser.w3.Eea)
    },
    onSignInError (error) {
      this.$toasted.error('Something went wrong... please try again')
      // `error` contains any error occurred.
      console.log('ERROR_WHILE_THIRD_PARTY_SIGN_IN : ', error)
    },
    showRating (contentID) {
      this.$store.dispatch('showRating', {'profileId': this.$store.getters.getProfileDetails.profileId, 'contentId': contentID, 'rating': this.rating}).then(response => {
        this.$toasted.success(this.$t('common.alerts.RATING_ADDED'))
      }, error => {
        this.$toasted.error(error)
        console.log('error in adding rating', error)
      })
    },
    checkValue (val) {
      if (val === '') {
        return false
      } else {
        return true
      }
    },
    // makes URL for CDP path
    makePath (path) {
      return CDP_CDN_THUMBNAIL_URL + '/' + path
      // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
    },
    goToPlaylist: function () {
      this.$toasted.info(this.$t('profileDetails.alerts.noVideosToDisplay'), { theme: 'primary', duration: 3000 })
      setTimeout(() => this.$router.push('playlist'), 2000)
    },
    setRating: function (rating) {
      this.rating = rating
    },
    learnCourse (course) {
      if (course.courseType === 'CO') {
        this.$store.dispatch('checkExpiryDateForCO', course)
      } else {
        var playlist = []
        playlist.push(this.$store.getters.getLOObjectByContentId(course.contentId))
        this.$store.dispatch('setCurrentContentViewerPlaylist', playlist)
        this.$store.dispatch('setIsPlaylist', false)
        this.$router.push('/frames')
      }
    },
    // checks whether user has not entered DOB greater than current date
    checkDob (dob) {
      if (dob !== null) {
        var dobDate = new Date(parseInt(dob.split('/')[0]), parseInt(dob.split('/')[1]) - 1, parseInt(dob.split('/')[2]))
        if (dobDate > new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    // returns string in proper format required for correct ISO conversion
    getDOB (dob) {
      return dob.split('/')[2] + ' ' + this.monthList[dob.split('/')[1] - 1] + ' ' + dob.split('/')[0] + ' 00:00 UTC'
    },
    saveBasicProfile () {
      var b = this
      if (b.in_name.length !== 0) {
        return new Promise((resolve, reject) => {
          if (b.in_profileImage.length === 0) { // profilePicNotUpdated
            b.in_profileImage = b.$store.getters.getProfileDetails.profileImg
            axios
            .post('r/updateUserData', {'profileId': b.$store.getters.getProfileDetails.profileId, 'fullName': b.in_name, 'profileImg': b.in_profileImage, 'aboutMe': b.in_aboutMe})
            .then(res => {
              b.in_profileImage = ''
              b.$store.dispatch('fetchProfile', b.$store.getters.getProfileDetails.profileId).then(function () {
                b.isEdit = false
                resolve()
              }).catch(function (err) {
                console.log('err profile fetched : ', err)
                reject()
              })
              resolve()
            })
            .catch(err => {
              console.log('ERROR_IN_UPDATING_PROFILE : ', err)
              reject(err)
            })
          } else {
            axios
            .post('r/updateUserData', {'profileId': b.$store.getters.getProfileDetails.profileId, 'fullName': b.in_name, 'profileImg': b.in_profileImage, 'aboutMe': b.in_aboutMe})
            .then(res => {
              b.in_profileImage = ''
              b.$store.dispatch('fetchProfile', b.$store.getters.getProfileDetails.profileId).then(function () {
                b.isEdit = false
                resolve()
              }).catch(function (err) {
                console.log('err profile fetched : ', err)
                reject()
              })
            })
            .catch(err => {
              console.log('ERROR_IN_UPDATING_PROFILE : ', err)
              reject(err)
            })
          }
        })
      } else {
        b.$toasted.error('Name Field cannot be empty')
      }
    },
    editBasicProfile () {
      this.editDOB = true
      this.isEdit = true
      this.in_name = this.$store.getters.getProfileDetails.fullName
      this.in_designation = this.$store.getters.getProfileDetails.designation
      this.in_email = this.$store.getters.getProfileDetails.email
      this.in_aboutMe = this.$store.getters.getProfileDetails.aboutMe
      this.in_skills = this.$store.getters.getProfileDetails.skills
      // this.in_profileImage = this.$store.getters.getProfileDetails.profileImg
      // alert('end')
    },
    fetchPlayList () {
      var playlistView = this
      return new Promise((resolve, reject) => {
        axios
          .post('o/getAllPlaylists', {
            profileId: playlistView.$store.getters.getProfileDetails.profileId
          })
          .then(response => {
            // console.log('getAllPlaylists')
            // console.log(response.data)
            playlistView.$store.commit('setUserPlaylists', response.data)
            // console.log(JSON.stringify(this.$store.getters.getcurrentPlaylist));
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
      })
    },
    goToContentViewer (playlist) {
      playlist.lastItemViewed.itemViewedDuration = parseInt(playlist.lastItemViewed.itemViewedDuration)
      var playlists = []
      playlists.push(playlist)
      return new Promise((resolve, reject) => {
        axios
          .post('r/learningobject/getlodatabyplaylist', playlists)
          .then(response => {
            this.$store.dispatch('setCurrentContentViewerPlaylist', response.data)
            if (response.data.length > 0) {
              this.contentPath = response.data[0].path[0].filePath
              this.$store.dispatch('setCurrentPlayingContent', response.data[0])
              this.$store.dispatch('setCurrentPlaylist', playlist)
              this.$store.dispatch('setIsPlaylist', true)
              this.$router.push('/frames')
            }
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
      })
    },
    learnLO (LO) {
      var LOObj = []
      return new Promise(resolve => {
        axios.post('r/learningobject/getlodatabyitemid', { itemId: LO.contentId }).then(Response => {
          if (Response.status === 200) {
            LOObj = Response.data
            this.$store.dispatch('setCurrentContentViewerPlaylist', LOObj).then(response => {
              resolve()
              this.$store.dispatch('setIsPlaylist', false).then(response => {
                this.$router.push('/frames')
              })
            })
          }
        })
      })
    },
    setImage (e) {
      const file = e.target.files[0]
      if (file !== undefined && file !== null && file.size !== undefined) {
        if (((file.size) / 1048576 > (this.dropzoneOptions.maxFilesize))) {
          this.loading = false
          this.fileExceedLimit = true
          return
        } else {
          this.fileExceedLimit = false
        }
        if (!file.type.includes('image/')) {
          alert('Please select an image file')
          return
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader()
          reader.onload = (event) => {
            this.imgSrc = event.target.result
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(event.target.result)
          }
          reader.readAsDataURL(file)
          // console.log(reader.readAsDataURL(file))
        }
      }
    },
    cropImage () {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
      this.$refs.cropper.replace(this.cropImg)
      this.isCropped = true
    },
    rotate () {
      // guess what this does :)
      this.$refs.cropper.rotate(90)
    },
    uploadImage () {
      // console.log(this.$refs.cropper.getCroppedCanvas())
      // console.log(this.cropImg)
      var blob
      if (this.isCropped) {
        blob = this.dataURItoBlob(this.cropImg)
      } else {
        blob = this.dataURItoBlob(this.imgSrc)
      }
      var fileToUpload = new File([blob], '', { type: 'image/jpeg', lastModified: Date.now() })
      this.selectedFile = fileToUpload
      this.loading = true
      this.ChangeProfilePic()
    },
    // convert base64/URLEncoded data component to raw binary data held in a string
    dataURItoBlob (dataURI) {
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1])
      } else {
        byteString = unescape(dataURI.split(',')[1])
      }
      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], {type: mimeString})
    },
    ErrorUploading (file, error) {
      if (error.includes('File is too big')) {
        this.$toasted.error(this.$t('profileDetails.errors.File_size_more_than_512'))
      } else if (error.includes('Extra File')) {
        this.$toasted.error(this.$t('profileDetails.errors.Can_not_upload_multiple_files'))
      }
      this.loading = false
      console.log(error)
    },
    ReplaceFile: function () {
      let uploadForm = this
      var replaceurl = this.basicProfile.profileImg.split(uploadForm.bussiness_header)
      var path = this.basicProfile.profileImg.split('/')
      var CDN_REPLACEURL = replaceurl[0] + 'o/FileUploadWithReplace'
      var filePath = 'ProfilePics/' + uploadForm.$store.getters.getProfileDetails.profileId
      // var filename = 'Profile_Img_' + uploadForm.$store.getters.getProfileDetails.profileId
      var filename = path[path.length - 1].split('#')
      var formData = new FormData()
      // console.log(path)
      formData.append('path', filePath)
      formData.append('fileName', filename[0])
      formData.append('file', uploadForm.selectedFile)
      var url = CDN_REPLACEURL
      return new Promise((resolve, reject) => {
        axios
          .post(url, formData, { headers: { 'Bussiness-Code': uploadForm.bussiness_header, 'Client-Code': uploadForm.client_header } })
            .then(Response => {
              if (Response.status === 202) {
                axios.post('r/updateUserData', {'profileId': uploadForm.$store.getters.getProfileDetails.profileId, 'fullName': uploadForm.in_name, 'profileImg': Response.data.filepath, 'aboutMe': uploadForm.in_aboutMe}).then(res => {
                  uploadForm.in_profileImage = ''
                  resolve()
                }).catch(function (err) {
                  console.log('err profile fetched : ', err)
                  reject(err)
                })
                uploadForm.in_profileImage = Response.data.filepath
                uploadForm.loading = false
                uploadForm.$store.commit('setProfileImg', Response.data.filepath)
                uploadForm.$toasted.success(this.$t('profileDetails.alerts.File_replace_success'))
                uploadForm.isCropped = false
              }
            }).catch(error => {
              console.log('err', error)
            })
      })
    },
    UploadFile: function () {
      let uploadForm = this
      if (!this.fileExceedLimit) {
        // this.DeleteFile(this.basicProfile.profileImg).then(function () {
        var filePath = 'ProfilePics/' + uploadForm.$store.getters.getProfileDetails.profileId
        var filename = 'ProfileImg_' + uploadForm.$store.getters.getProfileDetails.profileId
        // console.log(uploadForm.selectedFile)
        var formData = new FormData()
        formData.append('path', filePath)
        formData.append('fileName', filename)
        formData.append('file', uploadForm.selectedFile)
        // var url = 'http://10.2.10.42:9091/' + '?' + 's-o'
        var url = CDN_UPLOAD_URL
        return new Promise((resolve, reject) => {
          axios
            .post(url, formData, { headers: { 'Bussiness-Code': uploadForm.bussiness_header, 'Client-Code': uploadForm.client_header } })
            .then(Response => {
              // console.log(Response)
              if (Response.status === 201) {
                // console.log(Response.data.filepath)
                axios.post('r/updateUserData', {'profileId': uploadForm.$store.getters.getProfileDetails.profileId, 'fullName': uploadForm.in_name, 'profileImg': Response.data.filepath, 'aboutMe': uploadForm.in_aboutMe}).then(res => {
                  uploadForm.in_profileImage = ''
                  resolve()
                }).catch(function (err) {
                  console.log('err profile fetched : ', err)
                  reject(err)
                })
                uploadForm.$store.commit('setProfileImg', Response.data.filepath)
                uploadForm.in_profileImage = Response.data.filepath
                uploadForm.loading = false
                uploadForm.isCropped = false
                uploadForm.$toasted.success(uploadForm.$t('profileDetails.alerts.FILE_UPLOADED_SUCCESS'))
              }
            })
            .catch(error => {
              console.log('err', error)
            })
        })
        // }).catch(function (error) {
        //   console.error('Error in DeleteFileFromCDN : ' + error)
        // })
      } else {
        this.loading = false
        return
      }
    },
    /* fileAdded (file) {
      if (((file.size) / 1048576 > (this.dropzoneOptions.maxFilesize))) {
        this.loading = false
        this.fileExceedLimit = true
        return
      } else {
        // console.log('inside else')
        this.loading = true
        this.selectedFile = file
        this.ChangeProfilePic()
      }
      // console.log((file.size) / 1048576)
      // console.log(this.dropzoneOptions.maxFilesize)
    }, */
    ChangeProfilePic () {
      if (this.basicProfile.profileImg === '') {
        this.UploadFile()
      } else {
        this.ReplaceFile()
      }
    },
   /*  clearFiles () {
      if (this.$refs.myVueDropzone.getAcceptedFiles().length) {
      } else {
        this.selectedFile = ''
      }
    }, */
    DeleteFile (filePath) {
      let uploadForm = this
      return new Promise(function (resolve, reject) {
        var url = CDN_DELETE_URL
        var obj = {}
        obj.url = filePath
        axios
          .post(url, obj, { headers: { 'Bussiness-Code': CDN_BUSSINESSHEADER, 'Client-Code': CDN_CLIENTHEADER } })
          .then(Response => {
            if (Response.status === 200) {
              return new Promise((resolve, reject) => {
                axios
                 .post('r/removeDisplayPicture', {'profileId': uploadForm.$store.getters.getProfileDetails.profileId})
                 .then(res => {
                   if (res.status === 200) {
                     uploadForm.$store.dispatch('removeDiplayPictureFromStore').then(res => {
                       uploadForm.imgSrc = ''
                       resolve()
                     })
                   }
                 })
                .catch(err => {
                  console.log('ERROR_IN_UPDATING_THE_VALUE_PROFILE_PIC_PATH : ', err)
                  reject(err)
                })
              })
            }
          })
          .catch(error => {
            console.log('err', error)
            reject(error)
          })
      })
    },
    GetAllocatedVideosDetails () {
      this.$store.dispatch('fetchUserSingleConceptCollection', {'profileId': this.$store.getters.getProfileDetails.profileId, 'pageNo': 1})
    }
  },
  created () {
    // this.$store.dispatch('fetchProfile', this.$store.getters.getProfileDetails.profileId)
    // this.fetchPlayList()
    // alert(this.$store.getters.getProfileDetails.profileId)
    this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId).then(res => {
      var itemIdList = []
      // alert(JSON.stringify(this.$store.getters.getItemsEnrolledByType('CO')))
      for (let i = 0; i < this.$store.getters.getItemsEnrolledByType('CO').length; i++) {
        if (this.$store.getters.getItemsEnrolledByType('CO')[i].allocationDetails.completionPercentage === 100) {
          itemIdList.push({'contentId': this.$store.getters.getItemsEnrolledByType('CO')[i].contentId})
        }
      }
      this.$store.dispatch('getUserSkillsFromDB', itemIdList).then(res => {
        this.skills = res
      }, err => {
        console.log('ERROR_IN_FETCHING_USER_SKILLS : ', err)
      })
    }, err => {
      console.log('error in fetching enrolled item :', err)
    })
  },
  mounted () {
    this.GetAllocatedVideosDetails()
  },
  beforeDestroy () {
    if (this.in_profileImage !== '') {
      // alert('final delete')
      // this.DeleteFile(this.in_profileImage)
    }
  }
}
</script>
<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';
.loader-wraper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(255, 255, 255, 0.7);
  animation: fadeIn 0.5s ease-in-out;
  .loader-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #607d8b;
  }
  .lds-roller {
    display: block;
    position: relative;
    width: 64px;
    height: 64px;
    margin: 0 auto;
  }
  .lds-roller div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 32px 32px;
  }
  .lds-roller div:after {
    content: ' ';
    display: block;
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #607d8b;
    margin: -3px 0 0 -3px;
  }
  .lds-roller div:nth-child(1) {
    animation-delay: -0.036s;
  }
  .lds-roller div:nth-child(1):after {
    top: 50px;
    left: 50px;
  }
  .lds-roller div:nth-child(2) {
    animation-delay: -0.072s;
  }
  .lds-roller div:nth-child(2):after {
    top: 54px;
    left: 45px;
  }
  .lds-roller div:nth-child(3) {
    animation-delay: -0.108s;
  }
  .lds-roller div:nth-child(3):after {
    top: 57px;
    left: 39px;
  }
  .lds-roller div:nth-child(4) {
    animation-delay: -0.144s;
  }
  .lds-roller div:nth-child(4):after {
    top: 58px;
    left: 32px;
  }
  .lds-roller div:nth-child(5) {
    animation-delay: -0.18s;
  }
  .lds-roller div:nth-child(5):after {
    top: 57px;
    left: 25px;
  }
  .lds-roller div:nth-child(6) {
    animation-delay: -0.216s;
  }
  .lds-roller div:nth-child(6):after {
    top: 54px;
    left: 19px;
  }
  .lds-roller div:nth-child(7) {
    animation-delay: -0.252s;
  }
  .lds-roller div:nth-child(7):after {
    top: 50px;
    left: 14px;
  }
  .lds-roller div:nth-child(8) {
    animation-delay: -0.288s;
  }
  .lds-roller div:nth-child(8):after {
    top: 45px;
    left: 10px;
  }
  @keyframes lds-roller {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.profile-content {
  padding-top: 50px;
  padding-bottom: 50px;
  %card {
    .fa {
      vertical-align: middle;
      font-size: 14px;
    }
    border-radius: 3px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.18);
    border: none;
    background-color: #fff;
    transition: box-shadow 0.25s;
    padding: 25px;
  }
  
  .vue-dropzone {
    border: 2px dashed #bbb;
    // margin-top:10px;
    font-family: $opensans;
    // font-size:13px;
    padding-top: 30px;
    margin-bottom: 30px;
    background-color: #f7f7f7;
    border-radius: 5px;
    .dz-preview .dz-details {
      bottom: 0;
      top: 0;
      color: #555;
      background-color: #fff;
      transition: opacity 0.2s linear;
      text-align: left;
      border-radius: 4px;
      width: 120%;
      height: 120%;
      .dz-size {
        display: none;
      }
      .dz-filename:not(:hover) span {
        border: none;
        display: none;
      }
    }
    .dz-remove {
      position: absolute;
      z-index: 30;
      color: white;
      background-color: #aaa;
      margin-left: 15px;
      padding: 10px 20px;
      top: inherit;
      bottom: 15px;
      border-radius: 20px;
      border: none;
      text-decoration: none;
      text-transform: uppercase;
      font-size: 12px;
      font-family: $opensans;
      font-weight: 600;
      letter-spacing: 0.4px;
      opacity: 0;
      &:hover {
        text-decoration: none;
        background-color: #999;
      }
    }
    &:hover {
      background-color: #eee;
    }
    .dz-preview.dz-error .dz-error-message {
      display: none; }
  }
  .user-details {
    // min-height: 673px;
    hr{margin-left:-25px; margin-right:-25px; border-color:#eee;}
    @extend %card;
    input,
    textarea {
      box-shadow: none;
      font-size: 12px;
      background-color: #eee;
      border: none;
      padding: 13px 10px;
    }
    textarea {
      line-height: 18px;
    }
    .pic {
      text-align: center;
      img {
        border-radius: 90%;
      }
    }
    .upload-pic {
      .picture-inner {
        border: none;
      }
    }
    .title {
      div {
        padding-top: 10px;
        font-weight: 600;
        font-size: 16px;
        font-family: $opensans;
      }
      span {
        font-size: 14px;
        display: block;
        font-family: $opensans;
      }
      .views {
        font-size: 12px;
      }
    }
    .topic,
    label {
      font-weight: 600;
      font-size: 14px;
      font-family: $opensans;
    }
    .details {
      span {
        font-size: 14px; color:#888;
      }
    }
    .skills {
      margin-bottom: 30px;
      span {
        display: inline-block;
        background-color: #f5f5f5;
        padding: 5px 10px;
        border-radius: 4px;
        margin-top: 5px;
        font-size: 12px;
        margin-right:8px;
      }
      input {
        padding: 0px;
      }
      .vue-input-tag-wrapper {
        padding: 5px 10px;
        border: none;
        background-color: #eee;
        .new-tag {
          box-shadow: none;
        }
        .input-tag {
          background-color: #fff;
          border: none;
          padding-top: 2px;
          span {
            padding: 0px;
            color: #333;
            background-color: #fff;
          }
          .remove:before {
            color: #333;
            font-weight: 600;
            padding-left: 10px;
            font-size: 16px;
          }
        }
      }
    }
  }
  .card-tabs {
    @extend %card;
    .tabs-css {
      hr{margin-left:-25px;margin-right:-25px; border-color: #eee;}
      .nav-tabs {
        font-family: $opensans;
        font-weight: 600;
        font-size: 16px;
        outline: 0;
        box-shadow: none;
        border: none;
        .nav-link {
          padding: 0px;
          margin-right: 30px;
          border: none;
          background-color: transparent;
          color: #96abb5;
          &:active {
            color: #464a4c;
            background-color: transparent;
          }
        }
        .nav-link.active {
          color: #333;
        }
      }
      .tab-content {
        min-height: 553px;
      }
    }
  }
.noticemsg-alt{
  span{font-size:32px;}
  font-weight:400;
}
  .img-edit {
    position: relative;
    display: inline-block;
    .btn-edit {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0;
      width: 35px;
      height: 35px;
      border-radius: 50px;
      justify-content: center;
      background: #fff;
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
      opacity: 0;
      visibility: hidden;
      transition: all 0.2s ease-out;
      i {
        font-size: 20px;
        line-height: 32px;
      }
      &:hover {
        box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.25);
      }
    }
    &:hover .btn-edit {
      opacity: 1;
      visibility: visible;
    }
  } 
  .card-design.card-design-profile {
      // position: relative; 
      // margin-top:25px;
      // padding-bottom:30px;
      // border-bottom: 1px solid #eee;
      // margin-left:-25px;margin-right:-25px;
      // padding-left:25px;padding-right:25px;
      .card-design {
        &__img {
          width: 100%;border-radius: 5px;
          img {max-width: none; max-height: 100%; }
        }
        &__data-cost{span{ padding-left:3px; padding-right:3px; color: #77AE00;} font-size:14px; font-family: $opensans; color:#333;}
        &__data-heading {margin-bottom: 15px; height: auto;}
        &__details {font-size: 14px; line-height: 24px; color: #888; font-family: $opensans;
          strong {font-weight: 600; color: #333;}
        }
        &__data-ratings{margin-left:-15px; margin-top:15px;}
        &__data-ratings2{margin-left:-28px; margin-top:15px;}
        &__metadata{ span{display:inline-block; margin-top:0px;}}
        &__metadata2{ span{display:inline-block; margin-top:5px;}}
        &__count{text-align: right;}
      }
      box-shadow: none;
      .action-btn{margin-top:10px;}
  }
  @media screen and (max-width:375px){
    .card-design.card-design-profile {
    margin-top: 25px;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
     margin-left: 0px; 
     margin-right: 0px; 
    -webkit-box-shadow: none;
    box-shadow: none;
      .card-design {
        &__data-ratings{margin-left:-10px;}
        &__data-ratings2{margin-left:-22px;}

        // .vue-star-rating{margin-left:10px;}
        &__img {height: 162px;}
         &__data-heading {margin-top:30px;}
      }
    }  
  }
  @media screen and (min-width:375px) and (max-width:500px){
    .card-design.card-design-profile {
    margin-top: 25px;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
     margin-left: 0px; 
     margin-right: 0px; 
    -webkit-box-shadow: none;
    box-shadow: none;
      .card-design {
        &__data-ratings{margin-left:-10px;}
        &__img {height: 162px;}
         &__data-heading {margin-top:30px;}
      }
    }  
  }
  @media screen and (min-width:501px){
    .card-design.card-design-profile {
      position: relative; 
      margin-top:25px;
      padding-bottom:30px;
      border-bottom: 1px solid #eee;
      margin-left:-25px;margin-right:-25px;
      padding-left:25px;padding-right:25px;
      .card-design {
         &__data-heading {margin-top:0px;}
      }
    }
  }
}
.social-icon{
  i{
    cursor: pointer;
    &:hover{
      color: #ffc000
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/profile/profileContent.vue?3d2d2e00